'use client';

import React from 'react';
import { Wheat, Syringe, Package, ShieldCheck } from 'lucide-react';
import { InventoryItem } from './inventoryData';
import { MetricCard } from '@/components/ui/Cards';


interface Props {
  items: InventoryItem[];
}

export default function InventorySummaryCards({ items }: Props) {
  const categories = [
    { id: 'sc-feed', label: 'Feed Stock', category: 'Feed', icon: Wheat, color: '#15803d', bg: '#f0fdf4' },
    { id: 'sc-vaccine', label: 'Vaccines', category: 'Vaccine', icon: Syringe, color: '#2563eb', bg: '#eff6ff' },
    { id: 'sc-med', label: 'Medication', category: 'Medication', icon: ShieldCheck, color: '#d97706', bg: '#fffbeb' },
    { id: 'sc-other', label: 'Other Supplies', category: null, icon: Package, color: '#7c3aed', bg: '#faf5ff' },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-5">
      {categories.map((cat) => {
        const catItems = cat.category
          ? items.filter((i) => i.category === cat.category)
          : items.filter((i) => !['Feed', 'Vaccine', 'Medication'].includes(i.category));
        const totalVal = catItems.reduce((s, i) => s + i.totalValue, 0);
        const critCount = catItems.filter((i) => i.stockStatus === 'critical' || i.stockStatus === 'out-of-stock').length;
        const lowCount = catItems.filter((i) => i.stockStatus === 'low').length;

        return (
          <MetricCard
            key={cat.id}
            label={cat.label}
            value={`UGX ${(totalVal / 1000000).toFixed(1)}M`}
            sub={`${catItems.length} items${critCount > 0 ? ` · ${critCount} critical` : lowCount > 0 ? ` · ${lowCount} low` : ''}`}
            icon={cat.icon}
            iconBg={cat.bg}
            iconColor={cat.color}
          />
        );
      })}
    </div>
  );
}